import { BrowserRouter, Routes, Route } from "react-router-dom"
import { GoogleOAuthProvider } from "@react-oauth/google"

import LandingPage    from "./pages/LandingPage"
import Login          from "./pages/Login"
import Register       from "./pages/Register"
import Dashboard      from "./pages/Dashboard"
import Markets        from "./pages/Markets"
import Onboarding     from "./pages/Onboarding"
import RefundPage     from "./pages/RefundPage"
import TermsPage      from "./pages/TermsPage"
import PrivacyPage    from "./pages/PrivacyPage"
import VerifyEmail    from "./pages/VerifyEmail"
import Settings       from "./pages/Settings"

function App() {
    return (
        <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ""}>
            <BrowserRouter>
                <Routes>
                    <Route path="/"          element={<LandingPage />} />
                    <Route path="/login"     element={<Login />} />
                    <Route path="/register"  element={<Register />} />
                    <Route path="/onboarding" element={<Onboarding />} />
                    <Route path="/dashboard" element={<Dashboard />} />
                    <Route path="/markets"   element={<Markets />} />
                    <Route path="/settings"  element={<Settings />} />
                    <Route path="/verify"    element={<VerifyEmail />} />
                    <Route path="/refund"    element={<RefundPage />} />
                    <Route path="/terms"     element={<TermsPage />} />
                    <Route path="/privacy"   element={<PrivacyPage />} />
                </Routes>
            </BrowserRouter>
        </GoogleOAuthProvider>
    )
}

export default App
